import { render, staticRenderFns } from "./PalletOrderTable.vue?vue&type=template&id=cdc0657a&scoped=true"
import script from "./PalletOrderTable.vue?vue&type=script&lang=ts"
export * from "./PalletOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./PalletOrderTable.vue?vue&type=style&index=0&id=cdc0657a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc0657a",
  null
  
)

export default component.exports